import React, { RefObject, useEffect, useRef } from "react";

import clsx from "clsx";

import { TextareaBlocksProps } from "../../../../types/interfaces";
import styles from "../recruiting.module.scss";

const TextArea: React.FC<TextareaBlocksProps> = ({
    inputValues,
    handleInputChange,
    name,
    title,
    data,
    notVisible,
    isDisabled
}) => {
    const textareaRef: RefObject<HTMLTextAreaElement> = useRef(null);
    const valuesText = name === 'addresses' ? inputValues?.addresses?.join(';\n') || '' : inputValues[name] || '';

    const handleTextAreaChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (handleInputChange && event.currentTarget) {
            event.currentTarget.style.height = `${event.currentTarget.scrollHeight + 3}px`;
            handleInputChange(event as unknown as React.ChangeEvent<HTMLInputElement>);
        }
    };
    useEffect(() => {
        document.addEventListener('mousemove', resizeSibling);
        if (textareaRef.current) {
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight + 3}px`;
        }
        // eslint-disable-next-line
    }, [inputValues[name]]);

    const resizeSibling = () => {
        const textAreas = document.querySelectorAll(`textarea#textAreaComponent[name="${name}"]`);
        if (textAreas[0]) {
            const compStyles = getComputedStyle(textAreas[0])
            if (compStyles.visibility !== 'hidden') {
                textAreas[1]?.setAttribute('style', `height: ${textareaRef.current && textareaRef.current.scrollHeight + 3}px`)
            } else {
                textAreas[0]?.setAttribute('style', `height: ${textareaRef.current && textareaRef.current.scrollHeight + 3}px`)
            }
        }
    }

    const removeEvent = () => {
        document.removeEventListener('mousemove', resizeSibling);
    }
    return (
        <div
            className={clsx(
                styles.subBlock,
                styles.subBlock__right,
                styles.filterInput__textarea,
                notVisible && styles.notVisible
            )}>
            <textarea
                id={'textAreaComponent'}
                onMouseUp={removeEvent}
                ref={textareaRef}
                value={valuesText}
                onChange={handleTextAreaChange}
                className={clsx(styles.textarea, (data && data?.[name]?.changed) && styles.changed)}
                name={name}
                disabled={isDisabled}
                placeholder=' '
                rows={1}
            />
            <label>{title}</label>
        </div>
    )
}
export default TextArea;


